import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFloatingFormControl from 'UIComponents/form/UIFloatingFormControl';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UISelect from 'UIComponents/input/UISelect';
import PropertyRecord from '../records/PropertyRecord';
import TaxonomyInputUtils from '../utils/TaxonomyInputUtils';
import { TIER_FIT } from '../constants/ConversationsProperties';
import ThreadRecord from '../records/ThreadRecord';

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'Props' circularly references itself.
import { jsx as _jsx } from "react/jsx-runtime";
// @ts-expect-error ts-migrate(7022) FIXME: 'TierFitSelect' implicitly has type 'any' because ... Remove this comment to see the full error message
const TierFitSelect = ({
  allProperties,
  currentValue,
  displayMode,
  onChange,
  ghosted,
  threadRecord
}) => {
  const FormWrapper = displayMode === 'card' ? UIFloatingFormControl : UIFormControl;
  const shouldDisableInput = () => ghosted || !threadRecord.requiresProductAndTier();
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2604) FIXME: JSX element type 'FormWrapper' does not have any c... Remove this comment to see the full error message
    _jsx(FormWrapper, {
      label: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "app.taxonomy.property.tier.label"
      }),
      children: /*#__PURE__*/_jsx(UISelect, Object.assign({}, displayMode === 'panel' && {
        buttonUse: 'form'
      }, {
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        className: displayMode === 'card' ? 'p-left-0' : null,
        "data-test-id": "tier-fit-select-input",
        menuWidth: displayMode === 'panel' ? 350 : 250,
        onChange: ({
          target: {
            value
          }
        }) => onChange(new PropertyRecord({
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'undefined... Remove this comment to see the full error message
          name: TIER_FIT,
          value,
          revisionCode: currentValue ? currentValue.revisionCode : 0
        })),
        options: TaxonomyInputUtils.mapPropertiesToOptions({
          properties: allProperties,
          propertyKey: 'tier'
        }),
        placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "app.taxonomy.property.tier.placeholder"
        }),
        readOnly: shouldDisableInput(),
        value: currentValue ? currentValue.value : null
      }))
    })
  );
};
TierFitSelect.propTypes = {
  allProperties: ImmutablePropTypes.list.isRequired,
  currentValue: PropTypes.instanceOf(PropertyRecord),
  displayMode: PropTypes.string.isRequired,
  ghosted: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  threadRecord: PropTypes.instanceOf(ThreadRecord).isRequired
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
TierFitSelect.defaultProps = {
  currentValue: null,
  ghosted: false
};
export default TierFitSelect;